import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Image } from '../types/image.type';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private http: HttpClient) { }

  public addImage(image_data) : Observable<Image> {
    return this.http.post<Image>('/api/images', {
      data : image_data,
    })
  }

}
